import { useTranslation } from "@opendash/core";
import { Checkbox, Col, Row } from "antd";

import React from "react";

type CustomFormItemProps = {
  value?: any[];
  onChange?: (value: any[]) => void;
};

/**
 * A component that renders a calendar.
 * @param value initialValue passed by parent Form.Item.
 * @param onChange a callback for Form.Item to read its child component's value.
 * @constructor
 */
export const WeekDaySelect: React.FC<CustomFormItemProps> = ({
  value,
  onChange,
}) => {
  const t = useTranslation();

  const options = [
    { label: "Montag", value: "monday" },
    { label: "Dienstag", value: "tuesday" },
    { label: "Mittwoch", value: "wednesday" },
    { label: "Donnerstag", value: "thursday" },
    { label: "Freitag", value: "friday" },
    { label: "Samstag", value: "saturday" },
    { label: "Sonntag", value: "sunday" },
  ];

  return (
    <>
      <Row>
        <Col>
          <span>{t("gtfs:trip.create.modal.form.service.days.label")}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Checkbox.Group value={value} onChange={onChange} options={options} />
        </Col>
      </Row>
    </>
  );
};
